import useStyles from './styles';
import { ISingleToolAppIconProps } from './types';

function SingleToolAppIcon({ icon, isRound, size }: ISingleToolAppIconProps) {
  const classes = useStyles({
    size: size,
    backgroundColor: icon.background,
    iconWidth: icon.width,
    iconHeight: icon.height,
    iconColor: icon.fill,
    isRound,
  });
  const { src: Component } = icon;

  return (
    <div className={classes.root}>
      <Component />
    </div>
  );
}
export default SingleToolAppIcon;
